import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';
import { fetchRegion, fetchRegionByIp } from '~/api/global';
import { hostData } from '~/utils/urlHelpers';
import { maxAge } from '~/common/const';

export default defineNuxtPlugin(async () => {
  const initStore = useInteractiveStore();
  const globalStore = useGlobalStore();
  if (initStore.isPageSpeedBot || globalStore.isBot) return;
  const { domainWithPort, isSubdomain, domain, sub } = hostData(
    window.location.hostname,
    window.location.port
  );
  const getRegionByIp = async () => {
    const cookieRegion = useCookie('region', {
      path: '/',
      domain,
      maxAge,
    });
    if (!cookieRegion.value && !globalStore.isBot)
      return (await fetchRegionByIp()) || 1;
    return 1;
  };
  const regionId = await getRegionByIp();
  const checkSubdomain = () => {
    const cookieRegion = useCookie('region', {
      path: '/',
      domain,
      maxAge,
    });
    if (
      cookieRegion.value &&
      cookieRegion.value?.subdomain &&
      (!isSubdomain || sub !== cookieRegion.value?.subdomain)
    ) {
      // в дев режиме куки жутко глючат, что б локалилистов не трогало :)
      if (window.location.hostname === 'localhost') return false;
      const newLocation =
        '//' +
        (cookieRegion.value?.subdomain
          ? cookieRegion.value?.subdomain + '.'
          : '') +
        domainWithPort +
        window.location.pathname +
        window.location.search;
      navigateTo(newLocation, {
        external: true,
        redirectCode: 301,
      });
      return true;
    } else {
      return false;
    }
  };
  const isRedirect = checkSubdomain();
  if (isRedirect) return;
  if (regionId !== 1) {
    const regionData = await fetchRegion(regionId);
    if (regionData) globalStore.setLocalRegion(regionData);
  }
  if (!globalStore.localRegion) {
    globalStore.setLocalRegion(globalStore.region);
  }
});
